<template>
    <div>
        <v-overlay :value="isShow">
            <v-snackbar top="top" v-model="isShow" :color="color" :timeout="timeout">
                <v-list-item>
                    <v-list-item-content>
                        <v-alert class="text-center" :value="isShow" :type="displayType" transition="scale-transition">{{ message }}</v-alert>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn dark icon @click="isShow = false"><v-icon>mdi-close-circle</v-icon></v-btn>
                    </v-list-item-action>
                </v-list-item>
            </v-snackbar>
        </v-overlay>
    </div>
</template>

<script>

    export default {
        name: "Alert",

        components: {},

        data() {
            return {
                color: "transparent",
                isShow: false,
                message: "",
                displayType: "success",
                timeout: 5000
            };
        },
        
        methods: {
            async showAlert(displayType, message) {
                this.color = displayType;
                this.isShow = true;
                this.displayType = displayType;
                this.message = message;
                //由於v-snackbar 彈窗預設為5000毫秒，因此加500是確保，彈窗結束this.isShow 變成false
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        if (!this.isShow) { 
                            resolve(true);
                        }
                        reject(false);
                    }, this.timeout + 500);
                });
            },
        },
    };
</script>

<style>
.v-alert {
    margin: 0px !important;
}
</style>>